import React from 'react';
import { Skeleton_v2 as Skeleton } from '@mindly/ui-components';

const DiscountItemLoader = () => {
  return (
    <div className={'flex flex-col gap-4 rounded-[30px] p-5 bg-color-background-anti-flash-light'}>
      <div>
        <Skeleton className={'w-10/12 h-[18px] rounded-[12px] !mb-4'} />
        <Skeleton className={'w-11/12 h-[10px] rounded-[12px] !mb-2'} />
        <Skeleton className={'w-8/12 h-[10px] rounded-[12px]'} />
      </div>
      <div className={'border-t border-t-borders-divider pt-4 flex items-center justify-between'}>
        <Skeleton className={'w-4/12 h-[14px] rounded-[12px]'} />
      </div>
    </div>
  );
};

export default DiscountItemLoader;
